// =============================================================================
// Deep links from the home-screen widget.
//
//   eulea://day/<calendarId>/<yyyy-mm-dd>    open that day in that calendar
//   eulea://month/<calendarId>/<yyyy-mm>     open that month
//   eulea://new/<calendarId>/<yyyy-mm-dd>    open the new-event form
//   eulea://open/<tab>                        just switch to a page (the
//                                             domain widgets: todo, shopping,
//                                             timetracker, budget, birthdays)
//
// `calendarId` is 'personal' or a shared calendar's id. The listener is a
// no-op on the web, where the plugin is absent.
// =============================================================================

import { Capacitor } from '@capacitor/core';

export const parseDeepLink = (url) => {
  if (!url || typeof url !== 'string') return null;
  const m = url.match(/^eulea:\/\/(day|month|new|open)\/([^/?#]+)(?:\/([^/?#]+))?/i);
  if (!m) return null;
  const [, action, rawCalendar, value] = m;
  if (action.toLowerCase() === 'open') {
    return { action: 'open', tab: decodeURIComponent(rawCalendar), calendarId: null, value: null };
  }
  const calendarId = decodeURIComponent(rawCalendar);
  return {
    action: action.toLowerCase(),
    tab: calendarId === 'personal' ? 'calendar' : `shared:${calendarId}`,
    calendarId,
    value: value ? decodeURIComponent(value) : null
  };
};

// Calls `handler(parsed)` for the launch URL and every later open.
export const listenForDeepLinks = (handler) => {
  if (!Capacitor.isNativePlatform()) return () => {};
  let remove = () => {};
  import('@capacitor/app')
    .then(async ({ App }) => {
      const sub = await App.addListener('appUrlOpen', ({ url }) => {
        const parsed = parseDeepLink(url);
        if (parsed) handler(parsed);
      });
      remove = () => sub.remove();
      // Cold start: the app may have been launched by the link itself.
      const launch = await App.getLaunchUrl();
      const parsed = parseDeepLink(launch?.url);
      if (parsed) handler(parsed);
    })
    .catch(() => {});
  return () => remove();
};
